<template v-if="resultsLoaded">
  <li v-for="(item, index) in items" :key="item" :data-index="index + 1" class="Collection-Grid__Item">
    <ProductCard :item="item" />
  </li>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ProductCard from '../Global/ProductCard.vue';
import { FetchCards } from '../ProductCards/Composables/FetchCards.js';

const items = ref(null);
const resultsLoaded = ref(false);

const props = defineProps({
  data: [Object],
});

const loadCards = async (card) => {
  const data = await FetchCards(card);
  // apply variant id if any
  data.items.map((item, index) => {
    if (props.data[index].variant) item.handle = `${item.handle}?${props.data[index].variant}`;
  });

  items.value = data.items;
  showTitle();
  return (resultsLoaded.value = true);
};

const resetCards = () =>
  document.querySelector('.result-header .reset').addEventListener('click', () => {
    hideTitle();
    items.value = [];
    resultsLoaded.value = !resultsLoaded.value;
  });

const showTitle = () => document.querySelector('recommendation-list .h3').classList.remove('hidden');
const hideTitle = () => document.querySelector('recommendation-list .h3').classList.add('hidden');

onMounted(() => {
  loadCards(props.data);

  if (document.querySelector('.result-header .reset')) {
    resetCards();
  }
});
</script>
